import { tr } from "@/i18n";
// Text-only underlined sub-tabs, directly under the page header. tabs: [{ key, label, badge, testId }]
// dense: tighter padding + smaller text so a full tab set fits a half-width (split) pane.
// nowrap: one locked row that scrolls sideways instead of wrapping (phone portrait).
export default function SubTabs({ tabs, active, onChange, testId, className = "", dense = false, nowrap = false }) {
  const row = dense || nowrap ? "flex-nowrap overflow-x-auto" : "flex-wrap";
  return (
    <div className={`shrink-0 bg-background px-4 ${className}`} data-testid={testId}>
      <div className={`flex items-center ${row} ${dense ? "gap-0" : "gap-1"}`}>
        {tabs.map((t) => {
          const on = active === t.key;
          return (
            <button key={t.key} type="button" onClick={() => onChange(t.key)} data-testid={t.testId}
              className={`inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap border-b-2 font-medium transition-colors ${dense ? "px-2 py-2.5 text-xs" : "px-3 py-3 text-sm"} ${
                on ? "border-brand text-brand" : "border-transparent text-slate-500 hover:text-slate-800"}`}>
              {tr(t.label)}{t.badge || null}
            </button>
          );
        })}
      </div>
    </div>
  );
}
